import React, { createContext, useState, useEffect } from 'react'

export const ScrollContext = createContext()

const ScrollContextProvider =(props) => {
    const [ vHeight, setvHeight ] = useState(undefined)
    const [ scrollPos, setScrollPos ] = useState(undefined)
    const [ documentHeight, setdocHeight ] = useState(undefined)
    const [ color, setColor ] = useState('#fff')

    useEffect(() => {
        setdocHeight(document.body.clientHeight)
    },[])

    useEffect(() => {
        scrollPos/vHeight > .85 ? setColor('#000') : setColor('#fff')
        setdocHeight(document.body.clientHeight)
    },[scrollPos, vHeight])
    
    return ( 
        <ScrollContext.Provider value={{ vHeight, scrollPos, setvHeight, setScrollPos, color, documentHeight }}>
            {props.children}
        </ScrollContext.Provider>
    );
}
 
export default ScrollContextProvider;